import { render, staticRenderFns } from "./jianyanzu.vue?vue&type=template&id=71b9c12e&scoped=true&"
import script from "./jianyanzu.vue?vue&type=script&lang=ts&"
export * from "./jianyanzu.vue?vue&type=script&lang=ts&"
import style0 from "./jianyanzu.vue?vue&type=style&index=0&id=71b9c12e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b9c12e",
  null
  
)

export default component.exports